module.exports = __webpack_public_path__ + "img/360.04681466.svg";